import { getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { ThemeProvider } from "@mui/material";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { useGetWorkerVisitLockStatus } from "../useGetWorkerVisitLockStatus";
import { BookedVisitDetailsContent } from "./Content";
import { BookedVisitDetailsFooter } from "./Footer";
import { BookedVisitDetailsHeaderWrapper } from "./HeaderWrapper";

export function BookedVisitDetailsPage() {
  const { visit, isVisitLoading, isVisitError } = useInHomeVisitModalsDataContext();
  const { userId: workerId } = useDefinedWorker();

  const { data: lockResponse } = useGetWorkerVisitLockStatus(workerId, {
    refetchOnMount: true,
  });
  const lockedByWorkplaceId = lockResponse?.data?.attributes.lockedByWorkplaceId;

  const isPageDataSuccess = !isVisitLoading && !isVisitError;

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        {isDefined(visit) && (
          <BookedVisitDetailsHeaderWrapper isPageDataSuccess={isPageDataSuccess} />
        )}

        <BookedVisitDetailsContent lockedByWorkplaceId={lockedByWorkplaceId} />

        {!isVisitLoading && isDefined(visit) && (
          <BookedVisitDetailsFooter lockedByWorkplaceId={lockedByWorkplaceId} />
        )}
      </PageWrapper>
    </ThemeProvider>
  );
}
